import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {Table, PageHeader, Button, Input, message} from 'antd';
import {getUsersByOnJob} from '@/api/users';
import _ from 'lodash';
import {useAuthStore} from '@/context/auth';
import styles from '../index.module.less';
import {ClusterOutlined} from '@/icons';

import {getColumns} from '@/page/customer/InheritPage/userColumns';

function UserTable({
    user = null,
    onJob = 'true',
    isComponent = false,
    openModal,
    select,
    editable = false,
}) {
    const [authStore] = useAuthStore();
    const fatherId = _.get(authStore, 'user.extId');
    const [data, setData] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [loading, setLoading] = useState(false);
    const [current, setCurrent] = useState(1);
    const [size, setSize] = useState(10);
    const [url, setUrl] = useState(null);
    const [searchParam, setSearchParam] = useState({
        s: '',
        onJob: onJob,
        userId: _.isEmpty(user) ? '' : user.extId,
        fatherId: fatherId,
        current,
        size,
    });
    useEffect(() => {
        setUrl('/users/job');
        init(current);
    }, []);
    const rowSelection = {
        selectedRowKeys,
        type: 'radio',
        onChange: onSelectChange,
    };
    const extra = (
        <Input.Group compact>
            <Input
                className={styles.baseSearch}
                placeholder="请输入名称、邮箱或者电话"
                onChange={changeName}
            />
            <Button type="primary" onClick={() => init(1)}>
                查询
            </Button>
        </Input.Group>
    );
    let columns = getColumns(['avatar', 'email', 'mobile', 'position']);
    !isComponent &&
        columns.push({
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            render: (text, record) => (
                <Button
                    disabled={!editable}
                    type="text"
                    onClick={() => open(record)}
                    icon={<ClusterOutlined />}
                    style={{color: '#152D85'}}
                >
                    分配
                </Button>
            ),
        });

    function open(record) {
        openModal(record);
    }

    function init(pageNumber) {
        setLoading(true);
        setCurrent(pageNumber);
        searchParam.current = pageNumber;
        setSearchParam(searchParam);
        getUsersByOnJob(searchParam).then(res => {
            setData(res.data);
            setLoading(false);
        });
    }

    function changeName(e) {
        let temp = {...searchParam};
        temp.s = e.target.value;
        setSearchParam(temp);
    }

    function onSelectChange(selectedRowKeys) {
        if (selectedRowKeys.length > 1) message.error('只能选择单个员工');
        else {
            console.log('select', selectedRowKeys);
            setSelectedRowKeys(selectedRowKeys);
            select(selectedRowKeys[0]);
        }
    }

    function onShowSizeChange(current, pageSize) {
        setSize(pageSize);
        searchParam.size = pageSize;
        setSearchParam(searchParam);
        init(current);
    }

    function onChange(pageNumber) {
        init(pageNumber);
    }

    return (
        <>
            <div className={styles.header}>
                <PageHeader title={onJob === 'true' ? '在职继承' : '离职继承'} extra={extra} />
            </div>
            {/* {url && (
                <PageGrid
                    url={url}
                    columns={columns}
                    initParams={searchParam}
                    rowKey={'extId'}
                    tableProps={isComponent ? {rowSelection: rowSelection} : null}
                />
            )} */}
            <div className={styles.tableContainer}>
                <div style={{display: 'flex'}}>
                    <div className={styles.tableCorn}></div>
                    <div className={styles.tableContext}>
                        {onJob === 'true' ? '在职员工列表' : '离职员工列表'}
                    </div>
                </div>
                <Table
                    loading={loading}
                    columns={columns}
                    dataSource={data.records}
                    rowKey={record => record.extId}
                    rowSelection={isComponent && rowSelection}
                    style={{marginTop: 20}}
                    pagination={{
                        total: data.total,
                        showTotal: total => `共 ${total} 条记录`,
                        showSizeChanger: true,
                        onShowSizeChange: onShowSizeChange,
                        onChange: onChange,
                        current,
                        pageSize: size,
                    }}
                />
            </div>
        </>
    );
}

UserTable.propTypes = {
    user: PropTypes.object,
    onJob: PropTypes.string,
    isComponent: PropTypes.bool,
    openModal: PropTypes.func,
    select: PropTypes.func,
};

export default UserTable;
